// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qxa2","badges":"styles_badges__2GW4p"};